<template>
<ion-row>
  <ion-col v-if="datos" size-sm="6">
    <ion-item-divider>Tipos de servicio</ion-item-divider>
    <BarChart v-if="datacollection" :chart-data="datacollection" />
  </ion-col>
  <ion-col v-if="datos" size-sm="6">
    <ion-item-divider>Costos de servicio</ion-item-divider>
    <BarChart v-if="datacollectionCostos" :chart-data="datacollectionCostos" />
  </ion-col>
  <ion-col>
    <table>
      <thead>
        <tr>
          <th :colspan="empresa.calcularCostos?3:2">Costos de servicio</th>
        </tr>
        <tr>
          <th>Tipo</th>
          <th class="ion-text-right">Cantidad</th>
          <th class="ion-text-right" v-if="empresa.calcularCostos">Costos</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(d,indice) in datacollection.labels" :key="d">
          <td>{{d}}</td>
          <td class="ion-text-right">{{datacollection.datasets[0].data[indice]}}</td>
          <td class="ion-text-right" v-if="empresa.calcularCostos">{{datacollectionCostos.datasets[0].data[indice] | currency}}</td>
        </tr>
      </tbody>
    </table>
  </ion-col>
  <ion-col v-if="relacionCostos">
    <table>
      <thead>
        <tr>
          <th colspan="7">Relación de costos</th>
        </tr>
        <tr>
          <th>Equipo</th>
          <th>Cliente</th>
          <th>SN</th>
          <th>Fecha</th>
          <th class="ion-text-right">Cant.</th>
          <th>Tipo</th>
          <th class="ion-text-right" v-if="empresa.calcularCostos">P.U.</th>
          <th class="ion-text-right" v-if="empresa.calcularCostos">Importe</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in relacionCostos" :key="r._id">
          <td>{{r.equipo.alias}} {{r.equipo.marca}} {{r.equipo.modelo}}</td>
          <td>{{(r.cliente||{}).nombre}}</td>
          <td>{{r.equipo.sn}}</td>
          <td>{{r.fecha | moment('MMM DD')}} (OS{{r.folioOC}})</td>
          <td class="ion-text-right">{{r.cantidad | currency('')}}</td>
          <td>{{r.concepto}}</td>
          <td class="ion-text-right" v-if="empresa.calcularCostos">{{r.precioUnitario | currency}}</td>
          <td class="ion-text-right" v-if="empresa.calcularCostos">{{r.precioUnitario*r.cantidad | currency}}</td>
        </tr>
      </tbody>
    </table>
  </ion-col>
</ion-row>
</template>
<style>
table {
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 4px;
  font-size: 1em;
  border: 1px solid #cccccc;
}
</style>
<script>
import BarChart from '@/components/Extras/BarChart'
export default {
  name: 'ReporteTiposDeServicio',
  components: {
    BarChart
  },
  data() {
    return {
      modoProduccion: Api.modoProduccion,
      datacollection: null,
      datacollectionCostos: null,
      relacionCostos: null,
      empresa: {}
    }
  },
  props: {
    datos: {
      type: Object,
      default: function() {
        return {}
      }
    },
    catalogos: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    calcular() {
      let datacollection = {
        labels: [],
        datasets: [{
          label: 'Tipo de servicio',
          backgroundColor: '#f86060',
          data: []
        }]
      }
      let datacollectionCostos = {
        labels: [],
        datasets: [{
          label: 'Costo de tipo de servicio',
          backgroundColor: '#6060f8',
          data: []
        }]
      }
      let mapaTiposServicio = {}
      for (let orden of this.datos.ordenes) {
        if (!mapaTiposServicio[orden.tipoOrdenServicio])
          mapaTiposServicio[orden.tipoOrdenServicio] = {
            cantidad: 0,
            costo: 0
          }
        mapaTiposServicio[orden.tipoOrdenServicio].cantidad++
        if ((orden.costos || []).length > 0)
          mapaTiposServicio[orden.tipoOrdenServicio].costo += orden.costos
          .reduce((acum, obj) => acum + parseFloat(obj.cantidad * obj.precioUnitario), 0)
      }
      console.log({
        datacollection,
        datacollectionCostos
      })
      for (let tipo in mapaTiposServicio) {
        datacollection.labels.push(tipo)
        datacollectionCostos.labels.push(tipo)
        datacollection.datasets[0].data.push(mapaTiposServicio[tipo].cantidad)
        datacollectionCostos.datasets[0].data.push(mapaTiposServicio[tipo].costo)
      }
      this.datacollection = datacollection
      this.datacollectionCostos = datacollectionCostos
      //
      this.relacionCostos = []
      for (let orden of this.datos.ordenes)
        for (let costo of orden.costos || []) {
          console.log("Mapeando costo", orden.folio, costo)
          costo.equipo = orden.equipo
          costo.cliente = orden.cliente
          costo.fecha = orden.fechaCreada
          costo.folioOC = orden.folio
          this.relacionCostos.push(costo)
        }
    }
  },
  watch: {
    'datos': function(a) {
      this.calcular()
    }
  },
  async mounted() {
    this.empresa = (await Api.get('empresa'))[0] || {}
  },
  created() {
    this.calcular()
  }
}
</script>
